import React from 'react';
import volugraphLogo from '../assets/icons/Volugraph Logo.png';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[AppErrorBoundary]', error, info?.componentStack);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const isShopify = typeof window !== 'undefined'
      && window.location.pathname.startsWith('/shopify/');

    return (
      <div className="protected-route-loading" role="alert">
        <div className="protected-route-loading-content">
          <img src={volugraphLogo} alt="Volugraph" className="protected-route-logo" />
          <p className="app-error-boundary-message">
            {isShopify
              ? 'Something went wrong in the Volugraph app. Close this tab and reopen the app from Shopify admin, or reload below.'
              : 'Something went wrong loading this page.'}
          </p>
          <button
            type="button"
            className="app-error-boundary-reload"
            onClick={this.handleReload}
          >
            RELOAD PAGE
          </button>
        </div>
      </div>
    );
  }
}
